import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.masn.videoUrl}
    staticAnnotation={videos.masn.staticAnnotation}
    title="Watch MASN with Fubo"
    subtitle="Stream live games and local team coverage. Regional restrictions apply."
    networkSet="baseball"
    customNetworks={['masn']}
  />
)
